<script setup lang="ts">
defineProps({
  base: {
    type: String,
    default: '/',
    required: false,
  },
  label: {
    type: String,
    default: '',
  },
})

const breakpoints = useBreakpoints({
  'xs': '320px',
  'sm': '640px',
  'md': '768px',
  'lg': '1024px',
  'xl': '1280px',
  '2xl': '1536px',
  'xxl': '1536px',
})

onMounted(() => {
  const sidebarRef = document.getElementById('default-sidebar')

  if (sidebarRef) {
    const toggleSidebarMobile = (sidebarRef: any, sidebarBackdrop: any, toggleSidebarMobileHamburger: any, toggleSidebarMobileClose: any) => {
      sidebarRef.classList.toggle('hidden')
      sidebarBackdrop.classList.toggle('hidden')
      toggleSidebarMobileHamburger.classList.toggle('hidden')
      toggleSidebarMobileClose.classList.toggle('hidden')
    }

    const toggleSidebarMobileEl = document.getElementById('toggleSidebarMobile')
    const sidebarBackdrop = document.getElementById('sidebarBackdrop')
    const toggleSidebarMobileHamburger = document.getElementById('toggleSidebarMobileHamburger')
    const toggleSidebarMobileClose = document.getElementById('toggleSidebarMobileClose')
    const toggleSidebarMobileSearch = document.getElementById('toggleSidebarMobileSearch')

    toggleSidebarMobileSearch?.addEventListener('click', () => {
      toggleSidebarMobile(sidebarRef, sidebarBackdrop, toggleSidebarMobileHamburger, toggleSidebarMobileClose)
    })
    toggleSidebarMobileEl?.addEventListener('click', () => {
      toggleSidebarMobile(sidebarRef, sidebarBackdrop, toggleSidebarMobileHamburger, toggleSidebarMobileClose)
    })
    sidebarBackdrop?.addEventListener('click', () => {
      toggleSidebarMobile(sidebarRef, sidebarBackdrop, toggleSidebarMobileHamburger, toggleSidebarMobileClose)
    })

    // mobile - X < LG
    // desktop - X >= LG
    if (breakpoints.greaterOrEqual('lg').value)
      sidebarRef.classList.remove('hidden')
  }

  // setTimeout(() => initFlowbite(), 500)
})
</script>

<template>
  <nav class="fixed z-60 w-full border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
    <div class="px-3 py-3.5 lg:px-5 lg:pl-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center justify-start">
          <!-- open/close mobile menu -->
          <button id="toggleSidebarMobile" aria-controls="default-sidebar" type="button" class="cursor-pointer rounded p-2 text-gray-600 lg:hidden focus:bg-gray-100 hover:bg-gray-100 dark:text-gray-400 hover:text-gray-900 focus:ring-2 focus:ring-gray-100 dark:focus:bg-gray-700 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-gray-700">
            <span class="sr-only">Sidebar umschalten</span>
            <div id="toggleSidebarMobileHamburger" class="h-6 w-6" i-mdi-menu />
            <div id="toggleSidebarMobileClose" class="hidden h-6 w-6" i-mdi-close />
          </button>

          <!-- logo + title -->
          <a :href="base" class="ml-2 flex md:mr-24">
            <slot name="logo" />
            <span class="self-center whitespace-nowrap text-xl text-black font-semibold sm:text-2xl dark:text-white">{{ label }}</span>
          </a>
        </div>
        <div class="flex items-center">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </nav>
</template>
